import { PrintLabelHeader } from './PrintLabelHeader.component';
import { PrintLabelBody } from './PrintLabelBody.component';
import type { LabelBag } from '../../hooks/get-labels-by-date.hook';

interface PrintLabelProps {
  label: LabelBag;
}

export function PrintLabel({ label }: PrintLabelProps) {
  return (
    <div style={{ color: 'black', textAlign: 'center', pageBreakAfter: 'always' as const }}>
      <PrintLabelHeader
        title={label.title}
        deliveryDate={`${label.deliveryDate} (${label.schedule})`}
        deliveryCity={`${label.zip} - ${label.city.toUpperCase()}`}
        owner={label.ownerFullname}
      />
      <PrintLabelBody products={label.products} />
    </div>
  );
}
